import { BsVolumeMuteFill, BsVolumeDownFill, BsVolumeUpFill } from 'react-icons/bs';

export const LOCATION_OPTIONS = [
    "Lazaridis Hall",
    "University Library",
    "Fred Nichols Campus Centre",
    "Martin Luther University College",
    "Faculty of Arts",
    "Science & Research",
    "Dr. Alvin Woods Building",
    "Peters",
    "Schlegel"
];
  
export const SPACE_TYPE_OPTIONS = [
    'Group Study Room',
    'Independent Study Room',
    'Media Lab/Studio',
    'Meeting and presentation Space',
    'Open Space',
    'Study Carrel',
];
  
export const FEATURE_OPTIONS = [
    { value: 'Wifi', label: 'Wifi' },
    { value: 'Power Outlets', label: 'Power Outlets' },
    { value: 'Whiteboard', label: 'Whiteboard' },
    { value: 'Projector', label: 'Projector' },
    { value: 'Cafe', label: 'Cafe onsite' },
    { value: 'Couches', label: 'Couches / arm chairs' },
    { value: 'FoodAndDrinks', label: 'Food and drink allowed' },
    { value: 'privateDesks', label: 'Private Desks' },
    { value: 'accessible', label: 'Wheelchair/mobility device accessible' },
];
  
export const NOISE_LEVELS = [
    { value: 'quiet', icon: BsVolumeMuteFill, label: 'Quiet' },
    { value: 'moderate', icon: BsVolumeDownFill, label: 'Moderate' },
    { value: 'busy', icon: BsVolumeUpFill, label: 'Busy' },
];